import { Globe2 } from "lucide-react";
import { useLanguage } from "@/app/LanguageContext";

export const LanguageSelector = ({ compact = false, testId = "language-selector" }) => {
  const { language, languages, changeLanguage } = useLanguage();
  return (
    <label
      data-testid={testId}
      title="English is the current language. Additional languages can be added later."
      className={`inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white text-slatey ${compact ? "px-2.5 py-1.5" : "px-3.5 py-2"}`}
    >
      <Globe2 className="h-4 w-4 text-cobalt" aria-hidden="true" />
      <span className="sr-only">Language</span>
      <select
        aria-label="Language"
        value={language}
        onChange={(event) => changeLanguage(event.target.value)}
        className="cursor-pointer bg-transparent text-xs font-bold outline-none"
      >
        {languages.map((item) => (
          <option key={item.code} value={item.code}>{compact ? item.code.toUpperCase() : item.label}</option>
        ))}
      </select>
    </label>
  );
};
